import { Action } from "@ngrx/store";

export const systemEventTypes = {
    AppReady: "[SystemEvent] App Ready",
    BootingSystemEvent: "[SystemEvent] Boot Start",
    BootedSystemEvent: "[SystemEvent] Boot End",
    SyncDownStartEvent: "[SystemEvent] Sync Down Start",
    SyncDownEndEvent: "[SystemEvent] Sync Down End",
    SyncUpStartEvent: "[SystemEvent] Sync Up Start",
    SyncUpEndEvent: "[SystemEvent] Sync Up End",
    LoggedInEvent: "[SystemEvent] Logged In",
    LoggedOutEvent: "[SystemEvent] Logged Out"
};

export class BootingSystemEvent implements Action {
    readonly type = systemEventTypes.BootingSystemEvent;
}

export class BootedSystemEvent implements Action {
    readonly type = systemEventTypes.BootedSystemEvent;
}

export class SyncDownStartEvent implements  Action {
    readonly type = systemEventTypes.SyncDownStartEvent;
}

export class SyncDownEndEvent implements  Action {
    readonly type = systemEventTypes.SyncDownEndEvent;
}

export class SyncUpStartEvent implements  Action{
    readonly type = systemEventTypes.SyncUpStartEvent;
}

export class SyncUpEndEvent implements Action {
    readonly type = systemEventTypes.SyncUpEndEvent;
}

export class LoggedInEvent implements Action {
    readonly type = systemEventTypes.LoggedInEvent;
}

export class LoggedOutEvent implements Action {
    readonly type = systemEventTypes.LoggedOutEvent;
}

export class AppReadyAction implements Action {
    readonly type = systemEventTypes.AppReady;
}



// WEBPACK FOOTER //
// ./src/core/system/system.actions.ts